export const EVENT_NAME_CANCEL = 'cancel'
export const EVENT_NAME_CLOSE = 'close'
export const EVENT_NAME_HIDDEN = 'hidden'
export const EVENT_NAME_HIDE = 'hide'
export const EVENT_NAME_OK = 'ok'
export const EVENT_NAME_SHOW = 'show'
export const EVENT_NAME_SHOWN = 'shown'
export const EVENT_NAME_CLICK = 'click'
export const EVENT_NAME_DOUBLE_CLICK = 'doubleClick'
export const EVENT_NAME_CHANGE = 'change'
export const EVENT_NAME_ENTER = 'enter'
export const EVENT_NAME_REFRESH = 'refresh'

export const EVENT_NAME_BEFORE_LOAD = 'beforeLoad'
export const EVENT_NAME_AFTER_LOAD = 'afterLoad'



// WEBPACK FOOTER //
// ./src/components/treegrid/constants/events.js